import * as React from 'react';
import { Underlined, Bold, Italic, Strikethrough, H1, H2, H3, Mark, Link, Divider, UnorderedList, OrderedList, AlignLeft, AlignCenter, AlignRight, AlignJustify, ColorPicker } from './icons/Icons';
import { EditorState, DraftBlockType } from 'draft-js';
import { getSelectionInlineStyle, getSelectedBlocksType, } from "../draftjs-utils";
import { CompactPicker as Picker, ColorResult } from 'react-color';
import { Color } from 'csstype';
import { Grid } from '@material-ui/core';
import { ExtendedRichUtils, ALIGNMENTS } from '../utility/extendedRichUtils';

export interface IToolbarProps {
    editorState: EditorState;
    onUnderlineClick: () => void;
    onBoldClick: () => void;
    onItalicClick: () => void;
    onStrikeThroughClick: () => void;
    toggleBlockType: (blockType: DraftBlockType) => void;
    onHighlight: () => void;
    onAddImage: (canvas: any) => void;
    onAddLink: () => void;
    onToggleCode: () => void;
    onAlign: (align: ALIGNMENTS) => void;
    onSelectColor: (colorHex: string) => void;
    selectedColor?: Color;
}
export class CurrentStyles {
    bold: boolean;
    code: boolean;
    italic: boolean;
    strikethrough: boolean;
    subscript: boolean;
    superscript: boolean;
    underline: boolean;
    //blocktype: string;

    orderedlist: boolean;
    unorderedlist: boolean;

    h1: boolean;
    h2: boolean;
    h3: boolean;
    h4: boolean;
    h5: boolean;
    h6: boolean;

    alignleft: boolean;
    alignright: boolean;
    aligncenter: boolean;
    alingjustify: boolean;

    mark: boolean;
    link: boolean;
}

export interface IToolbarState {
    openColorPicker: boolean;
}
class ToolBar extends React.Component<IToolbarProps, IToolbarState>{
    constructor(p: IToolbarProps, c: any) {
        super(p, c);
        this.state = {
            openColorPicker: false
        }
    }
    toggleColorPicker = () => {
        const open = this.state.openColorPicker;
        this.setState({
            openColorPicker: !open
        });
    }
    render() {
        let styles = this.getCurrentStyles(this.props.editorState);
        return (<Grid item sm={12}>
            <Underlined onClick={this.props.onUnderlineClick} active={styles && styles.underline} />
            <Bold onClick={this.props.onBoldClick} active={styles && styles.bold} />
            <Italic onClick={this.props.onItalicClick} active={styles && styles.italic} />
            <Strikethrough onClick={this.props.onStrikeThroughClick} active={styles && styles.strikethrough} />
            <Divider />
            <UnorderedList onClick={this.props.toggleBlockType} active={styles && styles.unorderedlist} />
            <OrderedList onClick={this.props.toggleBlockType} active={styles && styles.orderedlist} />
            <Divider />
            {/* <Button onClick={this.props.onToggleCode}>Block</Button> */}
            <H1 onClick={this.props.toggleBlockType} active={styles && styles.h1} />
            <H2 onClick={this.props.toggleBlockType} active={styles && styles.h2} />
            <H3 onClick={this.props.toggleBlockType} active={styles && styles.h3} />
            <Divider />
            <AlignLeft onClick={this.props.onAlign} active={styles && styles.alignleft} />
            <AlignCenter onClick={this.props.onAlign} active={styles && styles.aligncenter} />
            <AlignRight onClick={this.props.onAlign} active={styles && styles.alignright} />
            <AlignJustify onClick={this.props.onAlign} active={styles && styles.alingjustify} />
            <Divider />
            <Mark onClick={this.props.onHighlight} active={styles && styles.mark} />
            <Link onClick={this.props.onAddLink} active={styles && styles.link} />
            {/* <UploadImage hideFileName={true} buttonIcon={<Image />} onFileLoad={(img: any) => this.props.onAddImage(img)} /> */}
            <ColorPicker onClick={this.toggleColorPicker} />
            {this.state.openColorPicker &&
                <Picker
                    color={this.props.selectedColor}
                    onChangeComplete={(c: ColorResult) => {
                        this.toggleColorPicker();
                        this.props.onSelectColor(c.hex)
                    }
                    } />}
        </Grid>
        )
    }
    getSelectionInlineStyleLoc = getSelectionInlineStyle;
    getSelectedBlocksTypeLoc = getSelectedBlocksType;
    getCurrentStyles = (editorState: EditorState) => {
        if (!editorState)
            return undefined;
        let styles = new CurrentStyles();

        let currentStyles = getSelectionInlineStyle(editorState);
        let currentBlockTypes = getSelectedBlocksType(editorState);
        styles.underline = currentStyles.UNDERLINE;
        styles.bold = currentStyles.BOLD;
        styles.italic = currentStyles.ITALIC;
        styles.code = currentStyles.CODE;
        styles.strikethrough = currentStyles.STRIKETHROUGH;
        styles.mark = currentStyles.HIGHLIGHT;


        styles.orderedlist = currentBlockTypes === 'ordered-list-item';
        styles.unorderedlist = currentBlockTypes === 'unordered-list-item';

        styles.h1 = currentBlockTypes === 'header-one';
        styles.h2 = currentBlockTypes === 'header-two';
        styles.h3 = currentBlockTypes === 'header-three';
        styles.h4 = currentBlockTypes === 'header-four';
        styles.h5 = currentBlockTypes === 'header-five';
        styles.h6 = currentBlockTypes === 'header-six';

        const alignment = ExtendedRichUtils.getCurrentAlignment(editorState);
        styles.aligncenter = alignment === ALIGNMENTS.CENTER;
        styles.alignleft = alignment === ALIGNMENTS.LEFT;
        styles.alignright = alignment === ALIGNMENTS.RIGHT;
        styles.alingjustify = alignment === ALIGNMENTS.JUSTIFY;
        return styles;
    }

}

export default ToolBar;